import React, { useState, useRef } from 'react';

const API = '/api';

export default function OdometroScanner({ busPlaca, busId, onGuardar, onClose }) {
  const [preview, setPreview] = useState(null);
  const [leyendo, setLeyendo] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [kmConfirmado, setKmConfirmado] = useState('');
  const [guardado, setGuardado] = useState(false);
  const fileRef = useRef();
  const cameraRef = useRef();

  const comprimirImagen = (file) => new Promise((resolve) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const maxSize = 1200;
      let w = img.width, h = img.height;
      if (w > maxSize || h > maxSize) {
        if (w > h) { h = Math.round(h * maxSize / w); w = maxSize; }
        else { w = Math.round(w * maxSize / h); h = maxSize; }
      }
      canvas.width = w; canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      canvas.toBlob(blob => resolve(blob), 'image/jpeg', 0.85);
      URL.revokeObjectURL(url);
    };
    img.src = url;
  });

  const procesarImagen = async (file) => {
    const comprimida = await comprimirImagen(file);
    const reader = new FileReader();
    reader.onload = async (e) => {
      const url = e.target.result;
      const b64 = url.split(',')[1];
      const mediaType = 'image/jpeg';
      setPreview(url);
      setResultado(null);
      setKmConfirmado('');
      setGuardado(false);
      setLeyendo(true);

      try {
        const resp = await fetch(`${API}/ocr-odometro`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ image: b64, mediaType })
        });

        const data = await resp.json();

        if (data.error) {
          setResultado({ error: data.error });
          return;
        }

        const texto = data.texto || '';
        const jsonMatch = texto.match(/\{.*\}/s);
        if (jsonMatch) {
          const parsed = JSON.parse(jsonMatch[0]);
          setResultado(parsed);
          if (parsed.odometro) setKmConfirmado(String(parsed.odometro));
        } else {
          setResultado({ error: 'No se pudo interpretar la imagen. Intenta con mejor iluminación.' });
        }

      } catch (err) {
        setResultado({ error: 'Error de conexión con el servidor. Verifica que esté corriendo.' });
      } finally {
        setLeyendo(false);
      }
    };
    reader.readAsDataURL(comprimida);
  };

  const handleFile = (e) => { const f = e.target.files[0]; if (f) procesarImagen(f); };
  const handleGuardar = () => {
    const km = parseInt(kmConfirmado);
    if (!km || km <= 0) return;
    onGuardar && onGuardar({ km, busPlaca, busId, fecha: new Date().toISOString() });
    setGuardado(true);
  };
  const confianzaColor = c => c==='alta'?'#4ade80':c==='media'?'#f59e0b':'#f87171';

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.85)', zIndex:300, display:'flex', alignItems:'center', justifyContent:'center', padding:'1rem' }}>
      <div style={{ background:'#13151f', border:'1px solid #2a2d3a', borderRadius:'12px', width:'100%', maxWidth:'440px', padding:'1.5rem' }}>

        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1.25rem' }}>
          <div>
            <div style={{ fontSize:'16px', fontWeight:'600', color:'#fff' }}>📸 Registrar odómetro</div>
            {busPlaca && <div style={{ fontSize:'12px', color:'#4ade80', marginTop:'2px' }}>{busPlaca} · {busId}</div>}
          </div>
          {onClose && <button onClick={onClose} style={{ padding:'5px 10px', background:'#2a2d3a', border:'none', borderRadius:'6px', color:'#fff', cursor:'pointer' }}>✕</button>}
        </div>

        {!preview && (
          <div style={{ display:'flex', gap:'10px', marginBottom:'1.25rem' }}>
            <button onClick={() => cameraRef.current.click()}
              style={{ flex:1, padding:'2rem 1rem', background:'#1a2a1a', border:'2px dashed #4ade80', borderRadius:'10px', color:'#4ade80', cursor:'pointer', textAlign:'center' }}>
              <div style={{ fontSize:'32px', marginBottom:'8px' }}>📷</div>
              <div style={{ fontWeight:'500', fontSize:'14px' }}>Tomar foto</div>
              <div style={{ fontSize:'11px', color:'#666', marginTop:'3px' }}>Con la cámara</div>
            </button>
            <button onClick={() => fileRef.current.click()}
              style={{ flex:1, padding:'2rem 1rem', background:'#1a1d27', border:'2px dashed #2a2d3a', borderRadius:'10px', color:'#aaa', cursor:'pointer', textAlign:'center' }}>
              <div style={{ fontSize:'32px', marginBottom:'8px' }}>🖼️</div>
              <div style={{ fontWeight:'500', fontSize:'14px' }}>Galería</div>
              <div style={{ fontSize:'11px', color:'#666', marginTop:'3px' }}>Foto existente</div>
            </button>
          </div>
        )}

        <input ref={cameraRef} type="file" accept="image/*" capture="environment" onChange={handleFile} style={{ display:'none' }} />
        <input ref={fileRef} type="file" accept="image/*" onChange={handleFile} style={{ display:'none' }} />

        {preview && (
          <div style={{ marginBottom:'1.25rem' }}>
            <img src={preview} alt="Odómetro" style={{ width:'100%', borderRadius:'8px', border:'1px solid #2a2d3a', maxHeight:'180px', objectFit:'cover' }} />
            <button onClick={() => { setPreview(null); setResultado(null); setKmConfirmado(''); setGuardado(false); }}
              style={{ marginTop:'8px', width:'100%', padding:'6px', background:'#2a2d3a', border:'none', borderRadius:'6px', color:'#aaa', cursor:'pointer', fontSize:'12px' }}>
              🔄 Cambiar imagen
            </button>
          </div>
        )}

        {leyendo && (
          <div style={{ marginBottom:'1.25rem', textAlign:'center' }}>
            <div style={{ fontSize:'28px', marginBottom:'8px' }}>🤖</div>
            <div style={{ fontSize:'13px', color:'#aaa' }}>Claude está analizando el odómetro...</div>
            <div style={{ fontSize:'11px', color:'#555', marginTop:'4px' }}>Esto toma unos segundos</div>
          </div>
        )}

        {resultado && !leyendo && (
          <div style={{ marginBottom:'1.25rem' }}>
            {resultado.error ? (
              <div style={{ background:'#3a1a1a', border:'1px solid #f87171', borderRadius:'8px', padding:'12px', color:'#f87171', fontSize:'13px' }}>
                ⚠ {resultado.error}
              </div>
            ) : (
              <div>
                <div style={{ background:'#1a2a1a', border:'1px solid #4ade80', borderRadius:'8px', padding:'16px', marginBottom:'12px', textAlign:'center' }}>
                  <div style={{ fontSize:'11px', color:'#666', marginBottom:'6px' }}>Odómetro detectado por Claude IA</div>
                  <div style={{ fontSize:'32px', fontWeight:'700', color:'#4ade80', letterSpacing:'2px' }}>
                    {resultado.odometro ? resultado.odometro.toLocaleString() + ' km' : 'No detectado'}
                  </div>
                  {resultado.confianza && (
                    <div style={{ fontSize:'11px', marginTop:'6px', color: confianzaColor(resultado.confianza) }}>
                      Confianza: {resultado.confianza}
                    </div>
                  )}
                </div>
                <div style={{ fontSize:'12px', color:'#666', marginBottom:'8px' }}>Confirma o corrige el valor:</div>
                <div style={{ display:'flex', gap:'8px', alignItems:'center' }}>
                  <input type="number" value={kmConfirmado} onChange={e => setKmConfirmado(e.target.value)}
                    placeholder="Km del odómetro"
                    style={{ flex:1, padding:'10px 12px', background:'#0f1117', border:'1px solid #2a2d3a', borderRadius:'8px', color:'#fff', fontSize:'16px', textAlign:'center' }} />
                  <span style={{ color:'#666', fontSize:'13px' }}>km</span>
                </div>
              </div>
            )}
          </div>
        )}

        {kmConfirmado && !guardado && (
          <button onClick={handleGuardar}
            style={{ width:'100%', padding:'12px', background:'#1d6a3a', border:'none', borderRadius:'8px', color:'#fff', cursor:'pointer', fontSize:'15px', fontWeight:'600' }}>
            ✅ Guardar {parseInt(kmConfirmado).toLocaleString()} km
          </button>
        )}

        {guardado && (
          <div style={{ background:'#1a3a2a', border:'1px solid #4ade80', borderRadius:'8px', padding:'16px', textAlign:'center' }}>
            <div style={{ fontSize:'28px', marginBottom:'6px' }}>✅</div>
            <div style={{ color:'#4ade80', fontWeight:'600' }}>Odómetro guardado</div>
            <div style={{ color:'#666', fontSize:'12px', marginTop:'4px' }}>{parseInt(kmConfirmado).toLocaleString()} km · {busPlaca}</div>
            <button onClick={onClose} style={{ marginTop:'12px', padding:'8px 20px', background:'#2a2d3a', border:'none', borderRadius:'6px', color:'#fff', cursor:'pointer', fontSize:'13px' }}>
              Cerrar
            </button>
          </div>
        )}

      </div>
    </div>
  );
}
